import { Badge } from './Badge';
import type { RunStatus } from '@/lib/types';

/**
 * RunStatus → Badge mapping. Single source of truth for how run states
 * render across the app (Dashboard, History, Live header…).
 */
export interface StatusBadgeProps {
  status: RunStatus;
  passed?: number | null;
  total?: number | null;
}

export function StatusBadge({ status, passed, total }: StatusBadgeProps) {
  switch (status) {
    case 'running':
      return <Badge kind="run">En cours</Badge>;
    case 'failed': {
      const f = passed != null && total != null ? total - passed : null;
      return <Badge kind="ko">{f != null ? `${f} fail` : 'Fail'}</Badge>;
    }
    case 'aborted':
      return <Badge kind="wr">Aborted</Badge>;
    case 'pending':
      return <Badge kind="nt">Pending</Badge>;
    case 'completed':
    default:
      return (
        <Badge kind="ok">
          {passed != null && total != null ? `${passed}/${total}` : 'Pass'}
        </Badge>
      );
  }
}
